<template>
  <!--<div class="home" :class="{'no-scroll': isPdfActive}">-->
  <div class="home">
    <intro-video ref="introvideo"></intro-video>
    <div class="slide-container">
      <div class="siema">
        <div class="slide" v-lazy:background-image="imgObjA">
          <div class="slide-a">
            <h1 class="slide-header">Certified High Quality Siberian Larch</h1>
            <div class="slide-sub-header">Building materials in New Zealand is more expensive than most of parts of the world. <span style="font-weight: bold; font-size: 150%; color: red">Do you want to save up to 70% on your next building project?</span></div>
            <button class="play-btn" ref="viewbtn" @click="showvideo">
              <svg viewBox="0 0 24 24">
                <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
              </svg>
            </button>
            <router-link to="/contact">
              <button class="learn-more-btn" @click="showPdf">
                Get A Quote
              </button>
            </router-link>
          </div>
        </div>
        <div class="slide" v-lazy:background-image="imgObjB">
          <div class="slide-a">
            <div class="slide-header">Directly from Siberia</div>
            <div class="slide-sub-header">We source only old growth and slow grown logs from certain regions in central Siberia</div>
            <button class="play-btn" ref="viewbtn" @click="showvideo">
              <svg viewBox="0 0 24 24">
                <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
              </svg>
            </button>
            <router-link to="/contact">
              <button class="learn-more-btn" @click="showPdf">
                Get A Quote
              </button>
            </router-link>
          </div>
        </div>
        <div class="slide" v-lazy:background-image="imgObjC">
          <div class="slide-a">
            <div class="slide-header">At a price without middlemen</div>
            <div class="slide-sub-header">You will be dealing with suppliers directly so our prices are competitive.</div>
            <button class="play-btn" ref="viewbtn" @click="showvideo">
              <svg viewBox="0 0 24 24">
                <path d="M8,5.14V19.14L19,12.14L8,5.14Z"/>
              </svg>
            </button>
            <router-link to="/contact">
              <button class="learn-more-btn" @click="showPdf">
                Get A Quote
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="dots">
        <div class="dot" v-bind:class="{ dotactive: activeDotA}" @click="goToSlide(0)"></div>
        <div class="dot" v-bind:class="{ dotactive: activeDotB}" @click="goToSlide(1)"></div>
        <div class="dot" v-bind:class="{ dotactive: activeDotC}" @click="goToSlide(2)"></div>
      </div>
    </div>


    <div class="app-divider"><span>Category</span></div>
    <div class="gallery-section">

      <!--<vue-gallery :images="gImages" :index="gIndex" @close="gIndex = null"></vue-gallery>-->

        <div
          v-for="(image, imageIndex) in gImages"
          class="image-card" v-lazy:background-image="{
          src: image.url,
          error: '',
          loading: '../../static/img/preload.jpg'
        }"
          :key="imageIndex"
          @click="gIndex = imageIndex">
          <router-link to="/gallery">
            <div class="image-text-area">
              <h4>{{image.type}}</h4>
            </div>
          </router-link>
        </div>

    </div>
    <!--<v-btn flat large color="primary" class="title" @click="showPdf">-->
      <!--View Brochures-->
      <!--<svg style="width:32px;height:32px" viewBox="0 0 24 24">-->
        <!--<path fill="#00796B" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />-->
      <!--</svg>-->
    <!--</v-btn>-->
    <a href="https://s3-ap-southeast-2.amazonaws.com/siberianlarchwood/brochure.pdf" target="_blank">
      <v-btn flat large style="color: red" class="title">
        View BROCHURES
        <svg style="width:32px;height:32px" viewBox="0 0 24 24">
          <path fill="red" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
        </svg>
      </v-btn>
      <!--<button class="products-details-btn">View ALL</button>-->
    </a>

    <div class="products-section">
      <div class="app-divider"><span>SIBERIAN LARCH</span></div>
      <div class="cards-container">
        <div class="intro-section">
          <div class="intro-text">
            <p>SUPREME WOOD PRODUCTS sources only old growth and slow grown logs from certain regions in central Siberia.</p>
            <p>This golden brown timber with clearly marked annual growth rings and straight grain grows in cold and harsh climate which gives Siberian Larch many fantastic natural attributes</p>
            <p>Siberian Larch’s high stability, density and versatility makes it desirable in many building projects.</p>
            <div class="features">
              <img class="feature-img"
                v-lazy="{
                src: '../../static/img/versatility.png',
                error: '',
                loading: ''
              }"/>
              <p class="features-point">VERSATILITY</p>
              <p class="features-point-text">Siberian Larch is very dense at 650kg - 700kg per m3 when dried. It is hard wearing and perfect for exposed elevations or high traffic areas. Suitable for both commercial and residential projects, from flooring to facades of houses, decor of interiors, decor of landscape elements.</p>
              <img class="feature-img"
                v-lazy="{
                src: '../../static/img/durability.png',
                error: '',
                loading: ''
              }"/>
              <p class="features-point">DURABILITY</p>
              <p>Siberian Larch has a maintenance free service life. The presence of resin in the wood creates a high resistance to decay and rot. The high density means that it is more difficult for decaying organisms to penetrate the wood. It makes it one of the toughest and most durable softwoods.</p>
            </div>
          </div>
          <div class="intro-card" v-lazy:background-image="{
                src: 'http://www.steinwoodproducts.com/uploadedimages/Deck%202_1000_1000.jpg',
                error: '',
                loading: ''
          }">
            <div class="card-header">GRADES</div>
            <div class="grade-section">
              <div class="grade-title">Grade A+</div>
              <div class="grade-text">This grade of Siberian Larch is the higher quality available. This is a clear grade timber, providing a clean , aesthetically pleasing and consistent look. Some are virtually knot-free. Excellent durability.</div>
              <div class="grade-title">Grade A</div>
              <div class="grade-text">This grade includes a mix of clear grades and allows some larger and a greater amount of knots. It gives a rustic and less uniform look. High level of density and hardness. Excellent durability.</div>
            </div>
          </div>
          <pdf-swipe></pdf-swipe>
        </div>
        <!--<v-btn flat large color="primary" class="title mt-5" @click="showPdf">-->
          <!--Download Brochures-->
          <!--<svg style="width:32px;height:32px" viewBox="0 0 24 24">-->
            <!--<path fill="#00796B" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />-->
          <!--</svg>-->
        <!--</v-btn>-->
      </div>
    </div>


    <div class="whyus-section">
      <div class="whyus-section-container">
        <div class="whyus-title">Why Us?</div>
        <div class="whyus-points-section">
          <div class="whyus-point">
            <svg class="svg-icon" viewBox="0 0 24 24">
              <path d="M11,21V16.74C10.53,16.91 10.03,17 9.5,17C7,17 5,15 5,12.5C5,11.23 5.5,10.09 6.36,9.27C6.13,8.73 6,8.13 6,7.5C6,5 8,3 10.5,3C12.06,3 13.44,3.8 14.25,5C14.33,5 14.41,5 14.5,5A5.5,5.5 0 0,1 20,10.5A5.5,5.5 0 0,1 14.5,16C14,16 13.5,15.93 13,15.79V21H11Z" />
            </svg>
            <div class="whyus-point-text">
              competitive price
            </div>
          </div>
          <div class="whyus-point">
            <svg class="svg-icon" viewBox="0 0 24 24">
              <path d="M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"/>
            </svg>
            <div class="whyus-point-text">
              zero middlemen
            </div>
          </div>
          <div class="whyus-point">
            <svg class="svg-icon" viewBox="0 0 24 24">
              <path d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"/>
            </svg>
            <div class="whyus-point-text">
              high quality woods
            </div>
          </div>
        </div>
        <div class="whyus-text">
          Because the business I run is smaller than the major retailers I can offer cheaper prices because I don't have the overheads of the major retailers.
        </div>

        <!--<button class="learn-more-btn" @click="showPdf">-->
          <!--Download Brochures-->
        <!--</button>-->
      </div>
    </div>


  </div>
</template>

<script>
  import Siema from 'siema'
  import IntroVideo from './IntroVideo.vue'
  import PDF from './Pdf.vue'
  import { mapState } from 'vuex'
  import VueGallery from 'vue-gallery'
  import VBtn from 'vuetify/es5/components/VBtn'
  export default {
    data () {
      return {
        imgObjA: {
          src: '../../static/img/home_a.jpg',
          error: '',
          loading: '../../static/img/preload.jpg'
        },
        imgObjB: {
          src: '../../static/img/home_b.jpg',
          error: '',
          loading: '../../static/img/preload.jpg'
        },
        imgObjC: {
          src: '../../static/img/home_c.jpg',
          error: '',
          loading: '../../static/img/preload.jpg'
        },
        activeDotA: true,
        activeDotB: false,
        activeDotC: false,
        // src: loadingTask,
        numPages: undefined,
        gImages: [
          {
            url: '../../static/img/gallery/wood1.jpg',
            type: 'Decking'
          },
          {
            url: '../../static/img/gallery/wood2.jpg',
            type: 'Cladding'
          },
          {
            url: '../../static/img/gallery/wood3.jpg',
            type: 'Flooring'
          },
          {
            url: '../../static/img/gallery/wood4.jpg',
            type: 'Panelling'
          }
        ],
        gIndex: null,
        dImages: [
          '../../static/img/cuts/cut1.png',
          '../../static/img/cuts/cut2.png',
          '../../static/img/cuts/cut3.png',
          '../../static/img/cuts/cut4.png',
          '../../static/img/cuts/cut5.png'
        ],
        dIndex: null
      }
    },
    computed: mapState({
      isPdfActive: 'isPdfActive'
    }),
    methods: {
      showvideo: function () {
        this.$refs.introvideo.show()
        this.$refs.introvideo.play()
      },
      onDot: function (index) {
        switch (index) {
          case 0:
            this.activeDotA = true
            this.activeDotB = false
            this.activeDotC = false
            break
          case 1:
            this.activeDotA = false
            this.activeDotB = true
            this.activeDotC = false
            break
          case 2:
            this.activeDotA = false
            this.activeDotB = false
            this.activeDotC = true
            break
          default:
            this.activeDotA = true
            this.activeDotB = false
            this.activeDotC = false
        }
      },
      showPdf: function () {
        this.$store.commit('showPdf')
      }
    },
    mounted: function () {
      const comp = this
      /* eslint-disable no-new */
      const siema = new Siema({
        duration: 300,
        onChange: function () {
          comp.onDot(this.currentSlide)
        }
      })
      this.goToSlide = (index) => {
        siema.goTo(index)
        this.onDot(index)
      }
    },
    components: {
      'intro-video': IntroVideo,
      'pdf-swipe': PDF,
      VueGallery,
      VBtn
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .no-scroll {
    height: 100vh;
    overflow: hidden;
  }
  .home {
    padding-top: 62px;
  }
  .slide {
    height: 80vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: relative;
  }
  .slide::before {
    content: '';
    display: block;
    position: absolute;
    background-color: #000;
    opacity: 0.35;
    width: 100%;
    height: 100%;
  }
  .slide-container {
    position: relative;
  }
  .dots {
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translate(-50%, 0);
    width: 40px;
    height: 10px;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    justify-content: space-between;
  }
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #FFF;
    opacity: .5;
    transition: opacity .2s ease-in;
  }
  .dotactive {
    opacity: 1;
  }
  .slide-a {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFF;
    width: 90%;
    margin-top: 25px;
  }
  .slide-header {
    font-size: 130%;
    font-weight: 600;
  }
  .slide-sub-header {
    padding-top: 10px;
    font-size: 100%;
    font-weight: 500;
  }
  .go-to-btn {
    background-color: #FFF;
    border: none;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    width: 150px;
    height: 40px;
    border-radius: 5px;
    font-size: 15px;
    margin-top: 20px;
  }
  .products-section {
    /*min-height: 90vh;*/
    width: 100vw;
    max-width: 1140px;
    margin: auto;
    padding-top: 5px;
    padding-bottom: 50px;
    font-size: 18px;
  }
  /*.products-section-header {*/
    /*font-size: 140%;*/
    /*font-weight: 600;*/
  /*}*/
  .app-divider {
    position: relative;
    width: 100%;
    height: 60px;
    /*background-color: yellow;*/
  }
  .app-divider span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #FFF;
    padding: 0 10px;
    z-index: 2;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 140%;
    width: 270px;
  }
  .app-divider:before {
    position: absolute;
    display: table;
    height: 1px;
    background: #999999;
    width: 96vw;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    content: '';
    z-index: 1;
  }
  .cards-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .intro-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .intro-text {
    /*background-color: red;*/
    padding: 15px;
    width: 100%;
    max-width: 650px;
  }
  .intro-text p {
    margin: 0;
    text-align: left;
    padding-bottom: 10px;
  }
  .features {
    padding-top: 20px;
  }
  .features-point {
    font-size: 120%;
    /*padding-bottom: 0 !important;*/
    font-weight: 600;
  }
  .feature-img {
    width: 60px;
    height: 60px;
    display: block;
    margin-bottom: 15px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    border-radius: 50%;
  }
  .intro-card {
    width: 90vw;
    max-width: 360px;
    min-height: 420px;
    border-radius: 3px;
    /*box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);*/
    border: none;
    text-align: left;
    box-sizing: border-box;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: relative;
    /*color: #FFF;*/
  }
  .intro-card::before {
    content: '';
    display: block;
    position: absolute;
    background-color: #EF5350;
    opacity: 0.2;
    width: 100%;
    height: 100%;
  }
  .card-header {
    padding: 20px 25px 0 25px;
    font-size: 150%;
  }
  .grade-section {
    padding: 20px 25px 0 25px;
    text-align: justify;
  }
  .grade-title {
    color: #424242;
    font-size: 120%;
  }
  .grade-text {
    padding-bottom: 15px;
  }
  .gallery-section {
    width: 100%;
    max-width: 1140px;
    min-height: 300px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 32px;
  }
  .image-card {
    width: 49vw;
    max-width: 400px;
    height: 49vw;
    max-height: 400px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    margin: 1px;
    cursor: pointer;
    transition: opacity .3s ease-in-out;
  }
  .image-card:hover {
    opacity: 1;
  }
  .image-text-area {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,.3);
  }
  .image-text-area h4 {
    color: #FFF;
    font-size: large;
    text-transform: uppercase;
  }
  .whyus-section {
    min-height: 30vh;
    width: 100vw;
    background-color: #dddfeb;
    padding-top: 35px;
    padding-bottom: 35px;
    margin-top: 32px;
  }
  .whyus-section-container {
    margin: auto;
    width: 100vw;
    max-width: 1140px;
  }
  .whyus-title {
    font-size: 200%;
    font-weight: 600;
    padding-bottom: 20px;
  }
  .whyus-points-section {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .whyus-point {
    max-width: 330px;
    width: 100vw;
    height: 120px;
  }
  .whyus-point-text {
    font-size: 110%;
  }
  .whyus-text {
    text-align: left;
    max-width: 800px;
    padding-left: 10px;
    padding-right: 10px;
    margin: auto;
  }
  .svg-icon {
    display: block;
    width: 60px;
    height: 60px;
    fill: #C5AE87;
    margin: auto;
  }
  .learn-more-btn {
    background-color: #009688;
    width: 150px;
    height: 40px;
    color: #FFF;
    margin-top: 30px;
    font-size: 100%;
    font-weight: 500;
    border-radius: 3px;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    border: none;
    cursor: pointer;
  }
  .products-details-btn {
    background-color: #009688;
    width: 220px;
    height: 40px;
    color: #FFF;
    margin-top: 30px;
    font-size: 100%;
    font-weight: 500;
    border-radius: 3px;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    border: none;
    cursor: pointer;
  }
  .play-btn {
    margin: 40px auto auto auto;
    width: 60px;
    height: 60px;
    background: none;
    color: #FFF;
    border: 4px solid #FFF;
    outline: none;
    border-radius: 50%;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    cursor: pointer;
    display: block;
  }
  .play-btn svg {
    fill: #FFF;
  }
  .pdf-thumb {
    width: 100px;
    height: 100px;
  }
  /*large screen*/
  @media screen and (min-width: 767px) {
    .slide {
      height: 45vh;
    }
    .slide-header {
      font-size: 200%;
      font-weight: 500;
    }
    .slide-sub-header {
      font-size: 130%;
      font-weight: 500;
    }
    .go-to-btn {
      cursor: pointer;
      transition: all .15s ease-in;
    }
    .go-to-btn:hover {
      background-color: #D3D3D3;
    }
    .dot {
      cursor: pointer;
    }
    .divider span {
      font-size: 200%;
      width: 350px;
    }
    .products-section {
      padding-top: 13px;
    }
    .image-card:hover {
      opacity: .6;
    }
    .card {
      margin: 15px;
    }
    .card:hover {
      opacity: .8;
    }
    .product-name {
      font-size: 120%;
    }
    .intro-card {
      margin-top: 16px;
    }
    .image-text-area h4 {
      font-size: 200%;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?f7c9ed24